import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'
import { Company } from 'modules/core/store/models/Company'

export class Companies extends Collection<Company> {
  constructor(data = []) {
    super(data)
    makeObservable(this, {
      current: computed,
    })
  }

  get cacheKey(): string {
    return 'companies'
  }

  get indexes() {
    return ['current']
  }

  get selected(): Company | null {
    const company = this.find({
      current: true,
    })

    return company ?? null
  }

  /**
   * @deprecated Before using this method, consider using the `useCurrentSession` hook since
   * we are trying to move away from using mobx-rest and use GraphQL instead.
   */
  get current(): Company {
    const company = this.selected

    if (!company) {
      throw Error('Error finding companies with current = true')
    }

    return company
  }

  model() {
    return Company
  }
}

const singleton: Companies = new Companies()

export default singleton
